import { FetchError } from "@medusajs/js-sdk"
import { HttpTypes } from "@medusajs/types"
import { UseMutationOptions, useMutation } from "@tanstack/react-query"
import { useClerk } from "@clerk/clerk-react"
import { sdk } from "../../lib/client"

export const useSignInWithEmailPass = (
  options?: UseMutationOptions<
    | string
    | {
        location: string
      },
    FetchError,
    HttpTypes.AdminSignUpWithEmailPassword
  >
) => {
  return useMutation({
    mutationFn: (payload) => sdk.auth.login("user", "emailpass", payload),
    onSuccess: async (data, variables, context, _ctx) => {
      options?.onSuccess?.(data, variables, context, _ctx)
    },
    ...options,
  })
}

export const useSignUpWithEmailPass = (
  options?: UseMutationOptions<
    string,
    FetchError,
    HttpTypes.AdminSignInWithEmailPassword
  >
) => {
  return useMutation({
    mutationFn: (payload) => sdk.auth.register("user", "emailpass", payload),
    onSuccess: async (data, variables, context, _ctx) => {
      options?.onSuccess?.(data, variables, context, _ctx)
    },
    ...options,
  })
}

export const useResetPasswordForEmailPass = (
  options?: UseMutationOptions<void, FetchError, { email: string }>
) => {
  return useMutation({
    mutationFn: (payload) =>
      sdk.auth.resetPassword("user", "emailpass", {
        identifier: payload.email,
      }),
    onSuccess: async (data, variables, context, _ctx) => {
      options?.onSuccess?.(data, variables, context, _ctx)
    },
    ...options,
  })
}

export const useSignInWithClerk = (
  options?: UseMutationOptions<
    string | { location: string },
    FetchError,
    { token: string }
  >
) => {
  return useMutation({
    mutationFn: (payload) => sdk.auth.login("user", "clerk", payload),
    onSuccess: async (data, variables, context, _ctx) => {
      options?.onSuccess?.(data, variables, context, _ctx)
    },
    ...options,
  })
}

export const useLogout = (options?: UseMutationOptions<void, FetchError>) => {
  const clerk = useClerk()

  return useMutation({
    mutationFn: async () => {
      await sdk.auth.logout()
      await clerk.signOut()
    },
    ...options,
  })
}

export const useUpdateProviderForEmailPass = (
  token: string,
  options?: UseMutationOptions<void, FetchError, HttpTypes.AdminUpdateProvider>
) => {
  return useMutation({
    mutationFn: (payload) =>
      sdk.auth.updateProvider("user", "emailpass", payload, token),
    onSuccess: async (data, variables, context, _ctx) => {
      options?.onSuccess?.(data, variables, context, _ctx)
    },
    ...options,
  })
}
